/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Router } from '@reach/router';
import ErrorBoundary from 'react-error-boundary';
import Header from '~components/Header';
// import logo from './logo.svg';
import { useAuth } from '~context/authContext';
import logger from '~util/logger';
import Login from './screens/Login';
import Overview from './screens/Overview';
import Search from './screens/Search';
import SessionTimeout from './screens/SessionTimeout';

// TODO: Check Token validity in useEffect here?

function App() {
  const { isAuthenticated } = useAuth();

  const appStyle = css`
    height: 100%;
    width: 100%;

    display: flex;
    flex-direction: column;
    justify-content: center;
  `;

  const contentContainerStyle = css`
    /* Account for height of Header component */
    height: calc(100% - 3rem);
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const MyFallbackComponent = ({ componentStack, error }) => (
    <div>
      <p>
        <strong>Oops! An error occured!</strong>
      </p>
      <p>Here’s what we know…</p>
      <p>
        <strong>Error:</strong> {error.toString()}
      </p>
      <p>
        <strong>Stacktrace:</strong> {componentStack}
      </p>
    </div>
  );

  return (
    <ErrorBoundary onError={logger.error} FallbackComponent={MyFallbackComponent}>
      <div className="app" css={appStyle}>
        <Header />
        <div css={contentContainerStyle}>
          {!isAuthenticated ? <UnauthenticatedApp /> : <AuthenticatedApp />}
        </div>
      </div>
    </ErrorBoundary>
  );
}

const UnauthenticatedApp = () => (
  <Router css={contentStyle}>
    <Login path="/" default />
    <SessionTimeout path="/logout" />
  </Router>
);

const AuthenticatedApp = () => (
  <Router css={contentStyle}>
    <Search path="/" default />
    <Overview path="/overview/nai/:nai" />
    <SessionTimeout path="/logout" />
  </Router>
);

const contentStyle = css`
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export default App;
